import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import colors from '~/theme/colors';

export const LoaderItem = styled('span')`
  position: relative;
  width: 5rem;
  height: 1rem;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background: ${colors.blue[600]};
    left: 0;
    top: 0;
  }

  &::before {
    box-shadow: 2rem 0 ${colors.blue[600]};
    animation: ballMoveX 1s linear infinite;
  }

  &::after {
    box-shadow: none;
    transform: translateX(4rem) scale(1);
    z-index: 1;
    animation: trfLoader 1s linear infinite;
  }

  @keyframes trfLoader {
    0%,
    5% {
      transform: translateX(4rem) scale(1);
      background: ${colors.blue[400]};
    }
    10% {
      transform: translateX(4rem) scale(1);
      background: ${colors.blue[400]};
    }
    40% {
      transform: translateX(2rem) scale(1.5);
      background: ${colors.blue[400]};
    }
    90%,
    95% {
      transform: translateX(0rem) scale(1);
      background: ${colors.uwmOrange[500]};
    }
    100% {
      transform: translateX(0rem) scale(1);
      background: ${colors.white};
    }
  }

  @keyframes ballMoveX {
    0%,
    10% {
      transform: translateX(0);
    }
    90%,
    100% {
      transform: translateX(2rem);
    }
  }
`;

export const LoaderItemLabel = ({ text }: { text: string }) => (
  <Typography fontWeight="800" color={colors.blue[600]} fontSize="1rem">
    {text}
  </Typography>
);
